import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './GlobalUtilities/css/App.css';

import LoginPage from './GlobalUtilities/login/LoginPage.js';
import PublicRoutes from './GlobalUtilities/protection/publicRoutes.js';
import PrivateRoutes from './GlobalUtilities/protection/privateRoutes.js';

import useAdmin from "./GlobalUtilities/protection/useAdmin.js";
import { USER_RIGHTS } from "./GlobalUtilities/constants/Constants.js";
import { useAuthentication } from "./GlobalUtilities/customHook/useAuthentecation.js";

import Dashboard from "./GlobalUtilities/DashBoard/DashBoard.js";

function App() {
  const { auth } = useAuthentication();
  const adminRoutes = useAdmin();

  return (
    <>
      <Routes>
        {/* Public Routes like login */}
        <Route element={<PublicRoutes />}>
          <Route path="/" element={<LoginPage />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>

        {/* Admin-specific routes */}
        {auth?.right === USER_RIGHTS.ADMIN && adminRoutes}
      </Routes>
    </>
  );
}

export default App;
